import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const MOCK_TOKEN: Readonly<string> = 'mock-access-token';
const AUTHORIZATION_HEADER: Readonly<string> = 'Authorization';

@Injectable()
export class MockAuthHeaderInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const withHeader: HttpRequest<unknown> = req.clone({
      setHeaders: { [AUTHORIZATION_HEADER]: `Bearer ${MOCK_TOKEN}` },
    });
    return next.handle(withHeader);
  }
}
